import { type HTMLContentType } from '@/common/types/dedicated-personal-page.type';
import { useQuery } from '@tanstack/react-query';

import Client from '@/common/utils/client.utility';

export const getDelivery = async () => {
  const client = new Client();
  return await client.get<HTMLContentType>('/v1/personalpage/Shopper/Delivery');
};

export const useGetDelivery = () =>
  useQuery({
    queryFn: getDelivery,
    queryKey: ['delivery'],
  });
